// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__XYxRE","notes":"Notes_notes__2TgCr"};